/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum LoyaltyRuleDependsCalcPeriodApiModel {
  All = 'all',

  Check = 'check',

  Day = 'day',

  Week = 'week',

  Month = 'month',

  ThreeMonth = 'three-month',

  Year = 'year',

  CurrentWeek = 'current-week',

  PastWeek = 'past-week',

  CurrentMonth = 'current-month',

  PastMonth = 'past-month',

  CurrentQuarter = 'current-quarter',

  PastQuarter = 'past-quarter',

  CurrentYear = 'current-year',

  PastYear = 'past-year'
}
